import * as Sentry from '@sentry/vue';
import type { PageProps } from '@inertiajs/core';
import type { App } from 'vue';

export function initSentry(app: App, pageProps: PageProps): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN_PUBLIC;

  if (!dsn) {
    return;
  }

  Sentry.init({
    app,
    dsn,
    release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
    environment: pageProps.app?.env ?? import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0),
    // Browser-extension artifacts, not application errors - see
    // https://github.com/getsentry/sentry-javascript/issues/3440
    ignoreErrors: [
      // Grammarly, LastPass, and other extensions injecting content into
      // iframes throw this legacy IE/Edge COM error when the page's DOM
      // mutates underneath them.
      'Object Not Found Matching Id',
    ],
  });

  const user = pageProps.auth?.user;

  if (!user) {
    return;
  }

  Sentry.setUser({
    id: user.id ?? undefined,
    email: user.email,
    username: user.name ?? undefined,
  });

  if (user.company) {
    Sentry.setTag('user.company_name', user.company.name);
    Sentry.setTag('user.company_id', user.company.id);
  }
}
